export default __webpack_public_path__ + "static/continuous-compliance-mobile1-eaad9b2c58823b73f3a77e6f9e9fc35a.jpg";